import { Component, OnInit, Input, HostListener, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { CouponService } from '@teem/app/core/services/coupon.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { LoaderService } from '@teem/services/loader.service';
import { SharedDataService } from '@teem/services/shared-data.service';
import { UserService } from '@teem/services/user.service';
import { messages as i18n } from '@teem/constants/messages';
declare var $;

@Component({
	selector: 'promo-code',
	templateUrl: './promo-code.component.html',
	styleUrls: ['./promo-code.component.scss']
})
export class PromoCodeComponent implements OnInit {
	isSubmitted: boolean = false;
	isUpdateSubmitted: boolean = false;
	promoCodes: any = [];
	promos: any = [];
	inactivePromoCodes: any = [];
	draftsPromoCodes: any = [];
	promoCode: any = {};
	isEdit: boolean = false;
	promoForm: FormGroup;
	promoUpdateForm: FormGroup;
	activePromoCodes: any[] = [];
	isActiveOptionsMenuVisible: boolean[] = [];
	isDraftOptionsMenuVisible: boolean[] = [];
	isInactiveOptionsMenuVisible: boolean[] = [];
	today: string;
	// isOptionsMenuVisibleTable1: boolean[] = [];
	// isOptionsMenuVisibleTable2: boolean[] = [];
	// isOptionsMenuVisibleTable3: boolean[] = [];
	isCouponActive: boolean[] = [];

	isPopupOpen = false; // Flag to control the popup visibility
	couponData = {}; // Data for the coupon to be edited
	isDraft = 0;
	saveBtnLabel: string = 'Save changes';

	constructor(private couponService: CouponService, private fb: FormBuilder, private loaderService: LoaderService) { }

	ngOnInit(): void {
		this.fetchPromoCodes();
		this.today = new Date().toISOString().split('T')[0];
		this.promoForm = this.fb.group({
			name: ['', Validators.required],
			coupon_code: ['', [Validators.required, Validators.min(3), Validators.max(24)]],
			discount: ['', [Validators.required, Validators.min(1), Validators.max(99)]],
			start_date: [this.today, Validators.required],
			end_date: ['', Validators.required],
			discount_type: ['percentage', Validators.required],
			is_draft: [0]
		});

		this.promoUpdateForm = this.fb.group({
			uuid: ['', Validators.required],
			name: ['', Validators.required],
			coupon_code: ['', [Validators.required, Validators.min(3), Validators.max(24)]],
			discount: ['', [Validators.required, Validators.min(1), Validators.max(99)]],
			start_date: [this.today, Validators.required],
			end_date: ['', Validators.required],
			discount_type: ['percentage', Validators.required],
			is_draft: [0]
		});
	}

	get f() {
		return this.promoForm.controls;
	}

	get uf() {
		return this.promoUpdateForm.controls;
	}

	formatDate(date: any) {
		return new Date(date).toISOString().split('T')[0];   // produces YYYY-MM-DD
	}

	changeExpiry() {
		const startDate = this.promoForm.get('start_date')?.value;
		const updateStartDate = this.promoUpdateForm.get('start_date')?.value;

		if (startDate) {
			const formatted = this.formatDate(startDate);
			this.promoForm.get('end_date')?.setValue(formatted);
		}

		if (updateStartDate) {
			const formattedUpdate = this.formatDate(updateStartDate);
			this.promoUpdateForm.get('end_date')?.setValue(formattedUpdate);
		}
	}


	convertToDateInputFormat(date: string): string {
		// const [day, month, year] = date.split('-');
		const [year, month, day] = date.split('-');
		return `${year}-${month}-${day}`;
	}

	toggleActiveOptionsMenu(index: number): void {
		let value = !this.isActiveOptionsMenuVisible[index]
		this.isActiveOptionsMenuVisible.fill(false);  // This resets all values to false
		this.isDraftOptionsMenuVisible.fill(false);   // This resets all values to false
		this.isInactiveOptionsMenuVisible.fill(false);
		this.isActiveOptionsMenuVisible[index] = value;
	}

	toggleDraftOptionsMenu(index: number, coupon: any): void {
		let value = !this.isDraftOptionsMenuVisible[index];
		const today = new Date();
		if (coupon?.start_date || coupon?.end_date) {
			const startDate = this.parseDate(coupon?.start_date);
			const endDate = this.parseDate(coupon?.end_date);

			if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
				// console.error("Invalid start or end date");
				return;
			}

			if (today >= startDate && today <= endDate) {
				this.isCouponActive[index] = true;
			} else {
				this.isCouponActive[index] = false;

			}
		}		
		this.isActiveOptionsMenuVisible.fill(false);  // This resets all values to false
		this.isDraftOptionsMenuVisible.fill(false);   // This resets all values to false
		this.isInactiveOptionsMenuVisible.fill(false);
		this.isDraftOptionsMenuVisible[index] = value;
	}

	toggleInactiveOptionsMenu(index: number): void {
		let value = !this.isInactiveOptionsMenuVisible[index];
		this.isActiveOptionsMenuVisible.fill(false);  // This resets all values to false
		this.isDraftOptionsMenuVisible.fill(false);   // This resets all values to false
		this.isInactiveOptionsMenuVisible.fill(false);
		this.isInactiveOptionsMenuVisible[index] = value;
	}

	@HostListener('document:click', ['$event'])
	onClickOutside(event: MouseEvent): void {
		const optionsMenu = document.querySelectorAll('.options-menu');
		const dotsMenu = document.querySelectorAll('.dots_container-rounded');

		// Check if the click was outside the options menu and dots menu
		const clickedOutside = !Array.from(optionsMenu).some(menu => menu.contains(event.target as Node)) &&
			!Array.from(dotsMenu).some(menu => menu.contains(event.target as Node));

		if (clickedOutside) {
			// Close all options menus by setting all values to false
			this.isActiveOptionsMenuVisible.fill(false);  // This resets all values to false
			this.isDraftOptionsMenuVisible.fill(false);   // This resets all values to false
			this.isInactiveOptionsMenuVisible.fill(false); // This resets all values to false
		}
	}

	parseDate(dateString: string): Date {
		// const [day, month, year] = dateString.split('-').map(num => parseInt(num, 10));
		const [year, month, day] = dateString?.split('-').map(num => parseInt(num, 10));
		const date = new Date(year, month - 1, day);
		if (date?.getDate() !== day || date?.getMonth() !== month - 1 || date?.getFullYear() !== year) {
			return new Date(NaN); // Return an invalid date if parsing failed
		}
		return date;
	}

	promoData = { campaignName: '', promoCode: '' };

	togglePopup(): void {
		this.isPopupOpen = !this.isPopupOpen;
	}

	saveDraft(): void {
		// console.log('Saving as draft:', this.promoData);
	}

	saveChanges(): void {
		// console.log('Saving changes:', this.promoData);
	}

	editPromo(coupon, table: string = ''): void {
		this.saveBtnLabel = 'Save changes';
		this.couponService.editPromoCode(coupon).subscribe(
			response => {
				if (coupon.start_date) {
					coupon.start_date = this.convertToDateInputFormat(coupon.start_date);
				}
				if (coupon.end_date) {
					coupon.end_date = this.convertToDateInputFormat(coupon.end_date);
				}
				this.promoUpdateForm.patchValue(coupon);
				if (table != 'activated') {
					this.saveBtnLabel = 'Save changes & activate';
				}

				const discountControl = this.promoUpdateForm.get('discount');
				if (coupon?.discount_type === 'percentage') {
					discountControl?.setValidators([Validators.required, Validators.min(1), Validators.max(99)]);
				} else {
					discountControl?.setValidators([Validators.required, Validators.min(1)]);
				}
				discountControl?.updateValueAndValidity();
				
				this.openPopup();
			},
			error => {
				this.closePopup();
				// Handle error (e.g., show an error message)
			}
		);
	}

	moveToDraft(coupon): void {
		this.couponService.moveToDraft(coupon).subscribe(
			response => {
				this.fetchPromoCodes();
			},
			error => {
				this.closePopup();
				// console.error('Error creating promo code:', error);
				// Handle error (e.g., show an error message)
			}
		);
	}

	activatePromo(coupon): void {
		this.couponService.activatePromo(coupon).subscribe(
			response => {
				this.fetchPromoCodes();
			},
			error => {
				this.closePopup();
				// console.error('Error creating promo code:', error);
				// Handle error (e.g., show an error message)
			}
		);
	}

	deletePromo(coupon): void {
		this.couponService.delete(coupon).subscribe(
			response => {
				this.fetchPromoCodes();
			},
			error => {
				// console.error('Error creating promo code:', error);
				// Handle error (e.g., show an error message)
			}
		);
	}

	// Close the popup
	closePopup(): void {
		this.isPopupOpen = false;
	}

	// open the popup
	openPopup(): void {
		this.isPopupOpen = true;
	}

	setDiscountType(type: string): void {
		this.promoForm.get('discount_type').setValue(type);  // Update the form control value

		const discountControl = this.promoForm.get('discount');

		if (type === 'percentage') {
			discountControl?.setValidators([Validators.required, Validators.min(1), Validators.max(99)]);
		} else {
			// Remove limits for flat amount
			discountControl?.setValidators([Validators.required, Validators.min(1)]);
		}

		discountControl?.updateValueAndValidity();
	}

	setUpdateDiscountType(type: string): void {
		this.promoUpdateForm.get('discount_type').setValue(type);  // Update the form control value

		const discountControl = this.promoUpdateForm.get('discount');

		if (type === 'percentage') {
			discountControl?.setValidators([Validators.required, Validators.min(1), Validators.max(99)]);
		} else {
			// Remove limits for flat amount
			discountControl?.setValidators([Validators.required, Validators.min(1)]);
		}

		discountControl?.updateValueAndValidity();
	}

	// Fetch all promo codes
	fetchPromoCodes() {
		this.couponService.getPromoCodes().subscribe(
			(response: any) => {
				this.activePromoCodes = response.data.active;
				this.inactivePromoCodes = response.data.inactive;
				this.draftsPromoCodes = response.data.drafts;
				// console.log('Promo Codes Fetched:', this.promoCodes); // Optional: Debugging log
			},
			(error) => {
				// console.error('Error fetching promo codes:', error); // Handle error
			}
		);
	}

	// Save as draft promo code
	saveAsDraft() {
		// this.promoForm.patchValue({ is_draft: 1 });
		this.promoForm.get('is_draft').setValue(1);
		['start_date', 'end_date']?.forEach((field: string) => {
			this.promoForm.get(field).setValue(null);
			this.promoForm.get(field).clearValidators();
			this.promoForm.get(field).updateValueAndValidity();
		});
		this.storePromocode();
	}

	savePromocode(): void {
		// this.promoForm.patchValue({ is_draft: 0 });
		this.promoForm.get('is_draft').setValue(0);
		['start_date', 'end_date']?.forEach((field: string) => {
			this.promoForm.get(field).setValidators([Validators.required]);
			this.promoForm.get(field).updateValueAndValidity();
		});
		this.storePromocode();
	}

	// Save a new or updated promo code
	storePromocode() {
		this.isSubmitted = true;
		if (this.promoForm.valid) {
			this.loaderService.startLoading();
			const promoData = this.promoForm.value;
			// Call the service to store the promo code
			this.couponService.createPromoCode(promoData).subscribe(
				response => {
					this.fetchPromoCodes();
					this.resetForm();
					this.isSubmitted = false;
					this.loaderService.stopLoading();
					// console.log('Promo code created successfully:', response);
					// Handle successful response (e.g., show a success message or navigate)
				},
				error => {
					this.loaderService.stopLoading();
					this.isSubmitted = false;
					// Set server side error
					if(error.status === 422) {
						if(error.error && error.error.errors && Object.keys(error.error.errors).length) {
							let validationErrors = error.error.errors;
							Object.keys(validationErrors).forEach((prop) => {
								this.promoForm.get(prop)?.setErrors({
									serverError: validationErrors[prop]
								})
							})
						}
					}
					Swal.fire(i18n.alert.error, i18n.getError(error), 'error');
					// console.error('Error creating promo code:', error);
					// Handle error (e.g., show an error message)
				}
			);
		} else {
			// this.promoForm.markAllAsTouched(); // Trigger validation messages
			// console.log('Form is not valid');
		}
	}

	setDraftValue(value: number): void {
		this.promoUpdateForm.patchValue({ is_draft: value });
	}

	updateSaveAsDraft(): void {
		this.promoUpdateForm.patchValue({ is_draft: 1 });
		['start_date', 'end_date']?.forEach((field: string) => {
			this.promoUpdateForm.get(field).setValue(null);
			this.promoUpdateForm.get(field).clearValidators();
			this.promoUpdateForm.get(field).updateValueAndValidity();
		});
		this.updatePromocode();
	}

	updateActivatePromocode(): void {
		this.promoUpdateForm.patchValue({ is_draft: 0 });
		['start_date', 'end_date']?.forEach((field: string) => {
			this.promoUpdateForm.get(field).setValidators([Validators.required]);
			this.promoUpdateForm.get(field).updateValueAndValidity();
		});
		this.updatePromocode();
	}

	updatePromocode() {
		this.isUpdateSubmitted = true;
		if (this.promoUpdateForm.valid) {
			const promoData = this.promoUpdateForm.value;
			// Call the service to store the promo code
			this.loaderService.startLoading();
			this.couponService.updatePromoCode(promoData).subscribe(
				response => {
					this.fetchPromoCodes();
					this.closePopup();
					this.resetUpdateForm();
					this.isUpdateSubmitted = false;
					this.loaderService.stopLoading();
				},
				error => {
					this.loaderService.stopLoading();
					this.isUpdateSubmitted = false;
					// Set server side error
					if(error.status === 422) {
						if(error.error && error.error.errors && Object.keys(error.error.errors).length) {
							let validationErrors = error.error.errors;
							Object.keys(validationErrors).forEach((prop) => {
								this.promoUpdateForm.get(prop)?.setErrors({
									serverError: validationErrors[prop]
								})
							})
						}
					}
					Swal.fire(i18n.alert.error, i18n.getError(error), 'error');
					// console.error('Error creating promo code:', error);
					// Handle error (e.g., show an error message)
				}
			);
		} else {
			this.promoUpdateForm.markAllAsTouched(); // Trigger validation messages
			// console.log('Form is not valid');
		}
	}

	// Reset the form
	resetForm() {
		this.isSubmitted = false;
		this.isEdit = false;
		this.promoCode = {};

		// Reset form controls to initial values (can be adjusted)
		this.promoForm.reset({
			name: '',
			coupon_code: '',
			discount: '',
			start_date: '',
			end_date: '',
			discount_type: 'percentage' // Reset to default value (e.g., 'percent')
		});

		// Optionally clear any error states
		Object.keys(this.promoForm.controls).forEach(key => {
			this.promoForm.get(key).setErrors(null);
		});
	}

	resetUpdateForm() {
		this.isUpdateSubmitted = false;
		this.isEdit = false;
		this.promoCode = {};

		// Reset form controls to initial values (can be adjusted)
		this.promoUpdateForm.reset({
			name: '',
			coupon_code: '',
			discount: '',
			start_date: '',
			end_date: '',
			discount_type: 'percentage', // Reset to default value (e.g., 'percent')
			is_draft: 0

		});

		// Optionally clear any error states
		Object.keys(this.promoUpdateForm.controls).forEach(key => {
			this.promoUpdateForm.get(key).setErrors(null);
		});
	}
}